import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import ServiceDrawerList from './ServiceDrawerList'
import ServiceCard from './ServiceCard'

const styles = theme => ({
  flexGrow: {
    flex: '1 1 auto'
  },
  drawerPaper: {
    maxWidth: '95%',
    backgroundColor: 'rgba(255, 255, 255, 0)',
    maxHeight: '100%',
    display: 'block',
    clear: 'both',
    borderRight: 0,
    overflow: 'hidden',
    maxHeight: 'max-content'
  }
})

const ServiceDrawer = props => {
  const {
    classes,
    open,
    handleClose,
    handleLocationClicked,
    handleLayerToggled,
    layersRendered,
    serviceCardActive,
    serviceCardChanged,
    services
  } = props

  return (
    <Drawer
      variant='persistent'
      open={open}
      onClose={handleClose}
      classes={{ paper: classes.drawerPaper }}
    >
      {!!serviceCardActive && (
        <ServiceCard service={serviceCardActive} {...props} />
      )}
      {!serviceCardActive && (
        <ServiceDrawerList
          handleLocationClicked={handleLocationClicked}
          handleLayerToggled={handleLayerToggled}
          layersRendered={layersRendered}
          serviceCardChanged={serviceCardChanged}
          services={services}
        />
      )}
    </Drawer>
  )
}

export default withStyles(styles)(ServiceDrawer)



// WEBPACK FOOTER //
// ./src/components/ServiceDrawer.js